import React from 'react';
import PropTypes from 'prop-types';
import css from './CwShellTopNav.scss';

const CwShellTopNav = (props) => {
  return (
    <div
      className={css.cwShellTopNav}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

CwShellTopNav.propTypes = {
  children: PropTypes.any,
  /**
   * Allows custom styling
   */
  style: PropTypes.object
};

export default CwShellTopNav;


// WEBPACK FOOTER //
// ./src/components/cwshelltopnav/CwShellTopNav.jsx